/**
 * @flow
 */

import React, { useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { isSameDay, differenceInCalendarDays } from 'date-fns';

import Calendar from '../../../../containers/Calendar';

function CalendarContainer({ value, dayPickerProps, onChange, ...rest }) {
    const isOwner = useSelector(({ user }) => user.get('isOwner'));

    const mergedDayPickerProps = useMemo(
        () =>
            Object.assign(
                {},
                {
                    disabled: isOwner
                        ? undefined
                        : {
                              before: new Date(),
                          },
                    selected: date =>
                        value
                            ? isSameDay(new Date(date), new Date(value))
                            : false,
                },
                dayPickerProps,
            ),
        [isOwner, value, dayPickerProps],
    );

    const handleChange = useCallback(
        date => {
            if (
                differenceInCalendarDays(new Date(date), new Date()) >= 0 ||
                isOwner
            ) {
                onChange(date);
            }
        },
        [isOwner, onChange],
    );

    return (
        <Calendar
            {...rest}
            isOwner={isOwner}
            value={value}
            dayPickerProps={mergedDayPickerProps}
            onChange={handleChange}
        />
    );
}

export default CalendarContainer;
